var _g;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIconServiceSaveMoney = function SvgIconServiceSaveMoney(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 81C63.0914 81 81 63.0914 81 41C81 18.9086 63.0914 1 41 1C18.9086 1 1 18.9086 1 41C1 63.0914 18.9086 81 41 81Z",
    stroke: "#007AFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 99"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M51.5602 33.0469C51.5033 32.9776 51.4183 32.9375 51.3286 32.9375H50.2912C50.1595 32.9375 50.0438 33.0236 50.0015 33.1483C49.8975 33.4554 49.7763 33.7503 49.6384 34.0318C49.5363 34.2402 49.6826 34.4937 49.9146 34.4937H50.5757C50.667 34.4937 50.7533 34.5353 50.8102 34.6067L54.4515 39.1723C54.6082 39.3688 54.4683 39.6593 54.217 39.6593H27.783C27.5317 39.6593 27.3918 39.3688 27.5485 39.1723L31.1898 34.6067C31.2467 34.5353 31.333 34.4937 31.4243 34.4937H32.1736C32.4114 34.4937 32.5573 34.2285 32.4447 34.019C32.2941 33.7387 32.1614 33.4452 32.0472 33.1396C32.0023 33.0194 31.8887 32.9375 31.7604 32.9375H30.6714C30.5817 32.9375 30.4967 32.9776 30.4398 33.0469L25.0683 39.5763C25.0242 39.63 25 39.6973 25 39.7669V58.2933C25 58.459 25.1343 58.5933 25.3 58.5933H56.7C56.8657 58.5933 57 58.459 57 58.2933V39.7669C57 39.6973 56.9759 39.63 56.9317 39.5763L51.5602 33.0469Z",
    fill: "#007AFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3352 37.3857H33.6652C33.3768 37.3857 33.1465 37.1543 33.1465 36.8669C33.1465 36.5816 33.3778 36.3482 33.6652 36.3482H36.7009C34.8428 35.013 33.631 32.8322 33.631 30.3682C33.631 26.2992 36.9312 23 40.9992 23C45.0671 23 48.3673 26.2992 48.3673 30.3682C48.3673 32.8322 47.1556 35.013 45.2974 36.3482H48.3352C48.6226 36.3482 48.8539 36.5816 48.8539 36.8669C48.8539 37.1543 48.6226 37.3857 48.3352 37.3857ZM39.6146 30.5808H38.718V29.765H39.6146V27.0162C39.7828 27.0162 40.0954 27.0122 40.4259 27.0081C40.7963 27.0034 41.1891 26.9984 41.426 26.9984C43.3198 26.9984 43.9054 27.7965 43.9054 28.8162C43.9054 29.8803 43.0911 30.5808 41.5724 30.5808H40.7307V31.3168H42.2311V32.1326H40.7307V33.2233H39.6146V32.1326H38.718V31.3168H39.6146V30.5808ZM42.716 28.9138C42.716 28.2665 42.3043 28.0182 41.545 28.0182C41.3321 28.0182 41.0716 28.0259 40.7932 28.0341C40.7724 28.0347 40.7516 28.0353 40.7307 28.0359V29.765H41.5358C42.1945 29.765 42.716 29.5434 42.716 28.9138Z",
    fill: "#007AFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 61"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.4463,
    y: 41.3125,
    width: 27.4203,
    height: 15.616,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 27.4463,
    y: 41.3125,
    width: 27.4203,
    height: 15.616,
    rx: 0.5,
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round",
    mask: "url(#path-4-inside-1)"
  }))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconServiceSaveMoney, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-service-save-money.d375dd45.svg";
export { ForwardRef as ReactComponent };